
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------


const _gormGateway_DomainControllerHelper = new Map<string, Object>();


export const gormGateway_DomainControllerHelper = _gormGateway_DomainControllerHelper;

